import styled from "styled-components";

export const Layout = styled.div`
  min-height: 100vh;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.adAssistant.layoutBgColor};
`;

export const ChatWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-height: 100vh;
  padding: 2rem 0 4rem;
  background: ${({ theme }) => theme.colors.adAssistant.jobSearcherBgColor};
  gap: 30px;
  position: relative;

  box-shadow: ${({ theme }) => `0px 0px 8px 0px ${theme.colors.adAssistant.previewBoxShadow}`};
`;

export const Header = styled.p`
  position: absolute;
  top: 1.2rem;
  left: 2rem;

  color: #7a89f4;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const LoadingPositioner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  height: 100%;
`;

export const Message = styled.p`
  color: ${({ theme }) => theme.colors.adAssistant.titleColor};
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  line-height: 1.4;
  font-weight: 400;

  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;

  max-width: 100%;
`;

export const BotMessage = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-right: 30px;

  img {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
  }

  ${Message} {
    margin-top: 5px;
  }
`;

export const LoadingWrapper = styled.div`
  margin: 0 2rem;
`;

export const MultiStepLoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 250px;
  gap: 1rem;
  overflow: hidden;
  position: relative;
`;

export const Step = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;

export const Task = styled.div`
  font-size: var(--fs-lg);
  color: var(--primary-blue);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`;

export const Group = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const Button = styled.button`
  padding: 6px 10px;
  gap: 6px;

  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;

  border-radius: 5px;
  color: ${({ theme }) => theme.colors.adAssistant.primaryColor};
  border: 1px solid ${({ theme }) => theme.colors.adAssistant.previewBorderColor};
  background: ${({ theme }) => theme.colors.adAssistant.chatMessage};

  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.adAssistant.chatMessage};
  }

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.adAssistant.jobSearcherBgColor};
    background: ${({ theme }) => theme.colors.adAssistant.primaryColor};
    border: 1px solid ${({ theme }) => theme.colors.adAssistant.primaryColor};
  }
`;
